import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthState } from '@shared/state/auth';
import { dapBffConfig } from '@dap/bff/config';

// TODO Add progress bar
// import { getFetchBaseQuery } from './rtk-progress';

// Either use URL from the .env file, or default to the one from the config for the current environment
const resolvedURL = process.env['NX_PUBLIC_DAP_BFF_API_V2_URL'] || dapBffConfig.urlV2;

const dapBffBaseQuery = fetchBaseQuery({
  baseUrl: `${resolvedURL}/api/v2`,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as { auth: AuthState }).auth.token;

    if (!token) {
      throw new Error('No access token');
    }
    headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
});

export const dapBffApiV2 = createApi({
  reducerPath: 'dapBffV2',
  baseQuery: dapBffBaseQuery,
  endpoints: () => ({}),
  tagTypes: ['SocialFeed', 'SocialFeedPost', 'SocialFeedPosts', 'Interactions'],
});
